/*  eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './CatelogueItem.css';
import { faImage } from '@fortawesome/free-solid-svg-icons';
import Modal from './Modals/Modal';
import BannerImageModal from './Modals/BannerImageModal';

function BannerImage({ curriculum, setCurriculum, lessonParent, isUploadingViaApi, setIsUploadingViaApi }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <div className="CIT NotYetAvailable" onClick={() => setIsOpen(true)}>
        <div className="CIT_A1">
          <FontAwesomeIcon icon={faImage} />
        </div>
        <div className="CIT_A2">
          Banner Image
        </div>
      </div>
      <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
        <BannerImageModal />
      </Modal>
    </div>
  );
}

export default BannerImage;
/*  eslint-enable no-unused-vars */
